import { useContext } from "react";
import "../../styles/Widgets/EditWidget.css";
import EditVerticalCylinderTankWidget from "./LiquidLevel/Widgets/EditVerticalCylinderTankWidget.jsx";
import { DashboardContext } from "../workspace_components/TenantAdministratorComponents/Dashboards/DashboardProvider.jsx";
import EditLineChartWidget from "./Charts/Widgets/EditLineChartWidget.jsx";
import EditBarChartWidget from "./Charts/Widgets/EditBarChartWidget.jsx";
import EditStateNavigationButtonWidget from "./Buttons/widgets/EditStateNavigationButtonWidget.jsx";
import EditRadialGaugeWidget from "./AnalogueGauges/widgets/EditRadialGaugeWidget.jsx";
const EditWidget = () =>{
    const {activeEditWidget} = useContext(DashboardContext);
    const renderEditComponent = () =>{
        if(!activeEditWidget) return null;
        switch(activeEditWidget?.type){
            case 'vertical_cylinder_tank':
                return <EditVerticalCylinderTankWidget/>;
            case 'line_chart':
                return <EditLineChartWidget/>;
            case 'bar_chart':
                return <EditBarChartWidget/>;
            case 'radial_gauge':
                return <EditRadialGaugeWidget/>;
            case 'state_navigation_button':
                return <EditStateNavigationButtonWidget/>;
            default:
                return null;
        }
    };
    return(
        <div className="edit-widgets-container">
            {renderEditComponent()}
        </div>
    );
};
export default EditWidget;